import { DetailedComplexEnumItem } from '../../utils/complexEnum/DetailedComplexEnumItem'

export class NotificationEventItem<
  Name extends string = string,
  ID extends string = string
> extends DetailedComplexEnumItem<ID, Name> {
  /**
   * a {@link NotificationEventItem} is just a {@link DetailedComplexEnumItem} for now
   *
   * we're extending DetailedComplexEnumItem to make things easier down the
   * line if we need to add any properties
   *
   * @see {@link NotificationEvent}
   */
  constructor(
    detailed: Pick<
      NotificationEventItem<Name, ID>,
      'id' | 'name' | 'description'
    >
  ) {
    super(detailed)
  }
}
